export const FEE_CODE = "feeCode";
export const FEE_NAME = "feeName";
export const DEFAULT_AMOUNT = "defaultAmount";
export const STATUS = "active";
export const DISPLAY_ORDER = "displayOrder";
export const COMMUNITY_ID = "communityId";